import { ArrowUpRight } from 'lucide-react';
import { Button } from 'primereact/button';
import { FC, useState } from 'react';
import WeeklyHistoryDialog from './WeeklyHistoryModal';
import { WeeklySnapshotQueryFilters } from '../WeeklySnapshot';
import { useQueryLoader } from 'react-relay';
import { DashboardGoalMetByWeekQuery } from '../../../graphQLOperations/__generated__/DashboardGoalMetByWeekQuery.graphql';
import { getGoalMetWeekly } from '../../../graphQLOperations/Dashboard';
import { getDatesRanges } from '../../../businessLogicService/dateHandlerForTeacherDashboard';

interface Props {
  queryFilters: WeeklySnapshotQueryFilters;
  variant?: 'card' | 'link';
}

const WeeklyHistory: FC<Props> = ({ queryFilters, variant = 'card' }) => {
  const dateRanges = getDatesRanges();

  const [weeklyHistoryDialogVisible, setWeeklyHistoryDialogVisible] = useState<boolean>(false);
  const [queryReference, loadQuery] = useQueryLoader<DashboardGoalMetByWeekQuery>(getGoalMetWeekly);

  const loadQueryHandler = () => {
    loadQuery({
      filter: {
        dateRanges: dateRanges,
        classIds: queryFilters.classIds,
        siteIds: queryFilters.siteIds,
        gradeLevelIds: queryFilters.gradeLevelIds,
        passedSkillGoal: 2,
      },
    });
    setWeeklyHistoryDialogVisible(true);
  };
  return (
    <>
      {variant === 'link' ? (
        <Button
          link
          label="See past weeks"
          icon={<ArrowUpRight size={16} />}
          className="tw-flex tw-flex-row-reverse tw-gap-x-1 tw-p-0 tw-font-atkinson tw-font-bold"
          onClick={loadQueryHandler}
        />
      ) : (
        <div
          id="WeeklyHistory"
          className="nc_teacher-dashboard-card-clickable mt-3 justify-content-center lg:p-3 xl:p-4 p-4 sm:col-6 lg:col-12"
          style={{ cursor: 'pointer' }}
          onClick={loadQueryHandler}
        >
          <div className="flex flex-row align-items-center text-primary">
            <div className="flex flex-row align-items-center border-none bg-transparent p-0">
              <h1 className="text-primary md:text-2xl text-base">Weekly History</h1>
              <i className="nc_icon-nc_right icon-sm ml-2"></i>
            </div>
          </div>
        </div>
      )}
      {weeklyHistoryDialogVisible && (
        <WeeklyHistoryDialog
          visible={weeklyHistoryDialogVisible}
          setVisible={setWeeklyHistoryDialogVisible}
          queryReference={queryReference}
        />
      )}
    </>
  );
};

export default WeeklyHistory;
